function buildOptionForOrders (records) {
  let times = []
  let downloadedAtValues = []
  let sentAtValues = []
  let sentHourValues = []
  let dailyProducts = []

  for (let item of records) {
    times.push(item.date)
    downloadedAtValues.push(item.downloaded_at)
    sentAtValues.push(item.sent_at.count)
    sentHourValues.push(item.sent_at.average_hours)
    dailyProducts.push(item.sent_at.products)
  }

  let option1 = {
    title: {
      text: '订单状态统计'
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['下载个数', '发货个数', '平均发货时间']
    },
    xAxis: {
      type: 'category',
      axisPointer: {
        type: 'shadow'
      },
      data: times
    },
    yAxis: [
      {
        type: 'value',
        name: '订单个数',
        axisLabel: {
          formatter: '{value} 个'
        }
      },
      {
        type: 'value',
        name: '发货历时',
        axisLabel: {
          formatter: '{value} h'
        },
        min: 0
      }
    ],
    series: [
      {
        name: '下载个数',
        type: 'line',
        data: downloadedAtValues
      },
      {
        name: '发货个数',
        type: 'line',
        data: sentAtValues
      },
      {
        name: '平均发货时间',
        type: 'bar',
        data: sentHourValues,
        yAxisIndex: 1
      }
    ]
  }

  return option1
}

function buildOptionForShippedOrders (records) {
  let times = []
  let downloadedAtValues = []
  let sentAtValues = []
  let sentHourValues = []
  let dailyProducts = []

  for (let item of records) {
    times.push(item.date)
    downloadedAtValues.push(item.downloaded_at)
    sentAtValues.push(item.sent_at.count)
    sentHourValues.push(item.sent_at.average_hours)
    dailyProducts.push(item.sent_at.products)
  }
  // 找到所有产品
  let allProductNames = new Set()
  for (let products of dailyProducts) {
    for (let product of products) {
      if (!allProductNames.has(product.product_name)) {
        allProductNames.add(product.product_name)
      }
    }
  }
  // 空白的product， 用0补齐
  let data = {}
  for (let productName of allProductNames.keys()) {
    data[productName] = []

    for (let products of dailyProducts) {
      let isIncluded = false
      for (let product of products) {
        if (product.product_name === productName) {
          data[productName].push(product.count)
          isIncluded = true
          break
        }
      }

      if (!isIncluded) {
        data[productName].push(0)
      }
    }
  }

  let option2 = {
    title: {
      text: '发货订单统计'
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {      // 坐标轴指示器，坐标轴触发有效
        type: 'shadow'    // 默认为直线，可选为：'line' | 'shadow'
      }
    },
    legend: {
      data: allProductNames
    },
    xAxis: {
      type: 'category',
      data: times
    },
    yAxis: {
      type: 'value'
    },
    series: []
  }

  for (let key in data) {
    option2.series.push({
      name: key,
      type: 'line',
      stack: 'one',
      areaStyle: {normal: {}},
      data: data[key]
    })
  }

  return option2
}

function buildOptionForCompany (title, records) {
  records = records.sort(function (a, b) { return a.value - b.value })

  let names = []
  for (let item of records) {
    names.push(item.name)
  }

  let option = {
    title: {
      text: title
    },
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    legend: {
      orient: 'vertical',
      x: 'right',
      data: names,
      textStyle: {
        fontSize: 10
      }
    },
    series: [
      {
        name: title,
        type: 'pie',
        radius: ['50%', '70%'],
        avoidLabelOverlap: false,
        label: {
          normal: {
            show: false,
            position: 'center'
          },
          emphasis: {
            show: true,
            textStyle: {
              fontSize: '30',
              fontWeight: 'bold'
            }
          }
        },
        labelLine: {
          normal: {
            show: false
          }
        },
        data: records
      }
    ]
  }
  return option
}

export {
  buildOptionForOrders,
  buildOptionForShippedOrders,
  buildOptionForCompany
}
